import React from 'react';
import { Section } from './ui/Section';
export function GuaranteeSection() {
  return <Section background="white" data-id="element-107">
      <div className="text-center" data-id="element-108">
        <div className="text-6xl mb-4" data-id="element-109">🤝</div>
        <h2 className="text-2xl md:text-3xl font-extrabold text-[#1e3a5f] mb-4" data-id="element-110">
          GARANTÍA DE PAZ POR 7 DÍAS
        </h2>
        <div className="bg-green-50 border-2 border-green-200 rounded-2xl p-6 max-w-xl mx-auto shadow-sm" data-id="element-111">
          <p className="text-[#2d3748] leading-relaxed text-sm md:text-base" data-id="element-112">
            Estamos tan seguros de la calidad de nuestro método que te damos una{' '}
            <strong data-id="element-113">semana completa</strong> para revisarlo. Si en los primeros{' '}
            <strong data-id="element-114">7 días</strong> sientes que las estrategias no son para tu
            familia, te devolvemos el{' '}
            <strong className="text-[#dc4a3d]" data-id="element-115">100% de tu dinero</strong>. Sin
            preguntas. El riesgo es todo nuestro.
          </p>
        </div>
      </div>
    </Section>;
}